import cookies from 'js-cookie';

/**
 * True when the visitor can make authenticated GraphQL calls: a user session cookie, or the
 * hash id + preview token pair of a logged-out previewer. Visitors the auth guard lets in
 * without either (calls/watch, calls/join, instructors/submissions) would only get an
 * AuthWrapper "cannot find a userId" error back.
 *
 * In local development the auth guard is bypassed (see `pages/_app.js` and
 * `utils/auth/authenticate.js`) and no cookies are set; the local backend resolves the user
 * from `secrets.js` instead, so authenticated queries must still be sent.
 */
export const hasUserSession = () =>
  process.env.NODE_ENV === 'development' ||
  Boolean(cookies.get('cl_ac') || (cookies.get('h_id') && cookies.get('c_ps')));
